import { Component, Input } from '@angular/core';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';
import { QineticPaymentSource, QineticPaymentSourcesService } from 'src/app/core/qinetic-payment-sources.service';
import { StripePaymentSource, StripePaymentSourcesService } from 'src/app/core/stripe-payment-sources.service';
import {
  ERROR_BUYER_DOCUMENT_NOT_FOUND_CODE,
  ERROR_ORDER_NOT_FOUND,
  ERROR_QINETIC_PAYMENT_SOURCES_NOT_FOUND_CODE,
  ERROR_STRIPE_PAYMENT_SOURCES_NOT_FOUND_CODE,
} from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-buyer-details-general',
  templateUrl: './buyer-details-general.component.html',
  styleUrls: ['./buyer-details-general.component.scss'],
})
export class BuyerDetailsGeneralComponent {
  @Input() buyer_id?: string | null;

  buyer?: Buyer;
  buyer_document_url?: string;
  last_contract_id?: string;
  payment_sources?: StripePaymentSource[];
  sdd_payment_sources?: QineticPaymentSource[];
  is_read_running = false;
  is_sources_list_running: boolean = false;
  is_sdd_list_running: boolean = false;
  is_document_read_running = false;

  constructor(
    private buyers_service: BuyersService,
    private error_service: ErrorService,
    private stripe_payment_sources_service: StripePaymentSourcesService,
    private qinetic_payment_sources_service: QineticPaymentSourcesService,
  ) {}

  ngOnInit(): void {
    this.last_contract_id = '-';
    this.readBuyer(this.buyer_id as string);
    this.readBuyerDocument(this.buyer_id as string);
    this.payment_sources = [];
    this.listPaymentSources();
    this.sdd_payment_sources = [];
    this.listSDDPaymentSources();
  }

  onRefresh(): void {
    this.last_contract_id = '-';
    this.readBuyer(this.buyer_id as string);
    this.readBuyerDocument(this.buyer_id as string);
    this.payment_sources = [];
    this.listPaymentSources();
    this.sdd_payment_sources = [];
    this.listSDDPaymentSources();
  }

  readBuyer(buyer_id: string): void {
    this.is_read_running = true;
    this.buyers_service.readBuyer(buyer_id).subscribe({
      next: response => {
        this.buyer = response.data;
        this.listOrders(buyer_id);
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  readBuyerDocument(buyer_id: string): void {
    this.is_document_read_running = true;
    this.buyers_service.readBuyerDocument(buyer_id).subscribe({
      next: response => {
        this.buyer_document_url = response.data;
        this.is_document_read_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_BUYER_DOCUMENT_NOT_FOUND_CODE) {
          this.buyer_document_url = '';
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_document_read_running = false;
      },
    });
  }

  listPaymentSources(): void {
    if (this.buyer_id) {
      this.is_sources_list_running = true;
      this.stripe_payment_sources_service.listPaymentSources(this.buyer_id).subscribe({
        next: response => {
          this.payment_sources = response.data;
          this.is_sources_list_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_STRIPE_PAYMENT_SOURCES_NOT_FOUND_CODE) {
            this.payment_sources = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_sources_list_running = false;
        },
      });
    }
  }

  listSDDPaymentSources(): void {
    if (this.buyer_id) {
      this.is_sdd_list_running = true;
      this.qinetic_payment_sources_service.listPaymentSources(this.buyer_id).subscribe({
        next: response => {
          this.sdd_payment_sources = response.data;
          this.is_sdd_list_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          console.log("Sono nell'error");
          console.log(error);
          if (processed_error.code == ERROR_QINETIC_PAYMENT_SOURCES_NOT_FOUND_CODE) {
            this.sdd_payment_sources = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_sdd_list_running = false;
        },
      });
    }
  }

  listOrders(buyer_id?: string): void {
    this.is_read_running = true;

    if (buyer_id) {
      this.buyers_service.listOrders(buyer_id).subscribe({
        next: response => {
          this.last_contract_id = response.data.sort((a: Order, b: Order) => {
            const date_b = b.completed_at ? new Date(b.completed_at).getTime() : 0;
            const date_a = a.completed_at ? new Date(a.completed_at).getTime() : 0;
            return date_b - date_a;
          })[0].contract_id;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
            this.last_contract_id = '-';
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
